<template>
  <app-modal
    v-model="isDialogOpened"
    transition="dialog-transition"
    :persistent="false"
    fullscreen
    hide-footer
    @cancel="closeDialog"
  >
    <template #title>
      <div class="WatermarkedViewerDialog__title d-flex align-center flex-wrap">
        <AppTooltip bottom>
          <template #activator="{ props }">
            <div
              class="WatermarkedViewerDialog__title__fileName text-truncated mr-1"
              v-bind="props"
              data-locator="file-name"
            >
              {{ watermarkedDialogData.file.basename }}
            </div>
          </template>
          <span>{{ watermarkedDialogData.file.basename }}</span>
        </AppTooltip>
        <div class="mr-1">{{ $t('project.documents.watermarked-viewer.WatermarkedViewerDialog.uploadedOn') }}</div>
        <DateDisplay
          :value="watermarkedDialogData.file.uploadTime"
          with-hours
          class="mr-1"
          data-locator="upload-date"
        />
        <div data-locator="uploaded-by">
          {{ $t('project.documents.watermarked-viewer.WatermarkedViewerDialog.uploadedBy') }} {{ watermarkedDialogData.file.uploadUser }}
        </div>
      </div>
    </template>
    <template #body>
      <WatermarkedDocumentsViewer
        :mnemo="mnemo"
        :file-id="watermarkedDialogData.file.id"
      />
    </template>
  </app-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import DateDisplay from '@/common/DateDisplay.vue'
import { dialogMixin } from '@/mixins/dialogMixin'
import { FilesActionTypes } from '@/store/modules/files/action_types'

import WatermarkedDocumentsViewer from './WatermarkedDocumentsViewer.vue'
export default {
  name: 'WatermarkedViewerDialog',
  components: {
    DateDisplay,
    WatermarkedDocumentsViewer,
    AppTooltip,
  },
  mixins: [dialogMixin],
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('files', ['watermarkedDialogData']),
  },
  beforeUnmount () {
    this.CANCEL_ALL_WATERMARKED_REQUEST_PENDING()
  },
  methods: {
    ...mapActions('files', [FilesActionTypes.CANCEL_ALL_WATERMARKED_REQUEST_PENDING]),
  },
}
</script>

<style scoped lang="scss">
@import "vuetify/settings";
.WatermarkedViewerDialog {
  &__title {
    &__fileName {
      max-width: 350px;
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        max-width: 250px;
      }
    }
  }
}
</style>
